interface IParamsReturn{
    [key: string]: string | null;
}

type IGetUrlParams = (params: string) => IParamsReturn | undefined;

const getUrlSearchParams: IGetUrlParams = (search: string | undefined) => {
	let obj: IParamsReturn = {} as IParamsReturn;
	let searchTerm = search;

	if(!searchTerm || searchTerm.trim().length === 0)
		return undefined;

	if(searchTerm.startsWith("?"))
		searchTerm = searchTerm.substring(1);
        
	const parseRestOfURL = JSON.parse(`{"${decodeURI(searchTerm).replace(/"/g, "\\\"").replace(/&/g, "\",\"").replace(/=/g,"\":\"").replace(/%2F/g, "/")  }"}`);
  
	obj = { 
		...parseRestOfURL
	};

	return obj;
};

export default getUrlSearchParams;
